import { memo } from 'react';
import { Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import {
  Add as AddIcon,
  Edit as EditIcon,
  RestartAlt as RestartAltIcon,
} from '@mui/icons-material';

function FormSaveAndSubmit({
  id,
  resetDisabled = false,
  submitDisabled = false,
  submitLoading = false,
  form,
  handleSubmit = () => {},
  handleReset = () => {},
}) {
  return (
    <Box sx={{ flex: 2, display: 'flex', justifyContent: 'end' }}>
      <Button
        disabled={resetDisabled || submitLoading}
        startIcon={<RestartAltIcon />}
        sx={{ color: 'secondary' }}
        variant="outlined"
        onClick={(e) => handleReset(e, form)}
        type="button">
        Reset
      </Button>
      <LoadingButton
        loadingPosition="start"
        loading={submitLoading}
        disabled={submitDisabled || submitLoading}
        startIcon={id === undefined ? <AddIcon /> : <EditIcon />}
        sx={{ color: 'primary', marginLeft: '10px' }}
        variant="contained"
        onClick={(e) => handleSubmit(e, form)}
        type="submit">
        {id === undefined ? 'Submit' : 'Update'}
      </LoadingButton>
    </Box>
  );
}

export default memo(FormSaveAndSubmit);
